module.exports = __webpack_public_path__ + "media/images/country_flags/bq-e21601d64088ba03dd263a6fa53fae9c.png";